import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/birthed_logo.png";

const HeroFrame = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--blue);
  color: var(--white);
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const HeroImg = styled.img`
  max-width: 434px;
  margin: 2rem;
`;

const HeroTitle = styled.h1`
  color: white;
  font-size: 4rem;
  font-family: var(--title);
  padding: 1rem;
`;

const HeroLevel = styled.div`
  display: flex;
  flex-direction: row;
  align-content: space-around;
  justify-content: space-around;
  padding: 1rem;
  min-width: 90vw;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 30vh;
  }
`;

const HeroLink = styled(Link)`
  display: block;
  background-color: var(--white);
  color: var(--blue);
  font-size: 2rem;
  border-radius: 0.5rem;
  text-decoration: none;
  padding: 0.5rem;
  text-align: center;
  font-family: var(--body);
`;

export function Splash() {
  localStorage.clear();
  return (
    <HeroFrame>
      <HeroImg src={logo} />
      <HeroTitle>Virtual Classroom</HeroTitle>
      <HeroLevel>
        <HeroLink to={"/classroom"}>Join Classroom</HeroLink>
      </HeroLevel>
    </HeroFrame>
  );
}
